/**
 * 光学计算模型：小孔成像/影子的相似三角形几何。
 *
 * 两者都是静态几何比例关系，不涉及反射/折射计算（docs/111-物理实验/007-物理实验.md §4.4）。
 */

/** 小孔成像用烛焰（自身发光，才谈得上"成像"）、影子用遮光物的固定"物高"（cm）——
 * 场景常量，不是变量，不进 PhysicsStore。 */
export const OBJECT_HEIGHT_CM = 6;

/**
 * 小孔成像的像高：物距 objectDistance（烛焰→孔）、像距 screenDistance（孔→屏）构成一对相似
 * 三角形，像高 = 物高 * 像距 / 物距。像本身是倒立的——这是渲染层的固定视觉事实，不体现在数值里。
 */
export function computePinholeImageHeight(
  objectDistanceCm: number,
  screenDistanceCm: number,
  objectHeightCm: number = OBJECT_HEIGHT_CM,
): number {
  return (objectHeightCm * screenDistanceCm) / objectDistanceCm;
}

/**
 * 影子的高度：光源→物 lightObjectDistanceCm、物→屏 objectScreenDistanceCm，
 * 光源到屏的总距离 / 光源到物的距离 = 影高 / 物高（相似三角形）。影子方向与物体一致，不倒立。
 */
export function computeShadowHeight(
  lightObjectDistanceCm: number,
  objectScreenDistanceCm: number,
  objectHeightCm: number = OBJECT_HEIGHT_CM,
): number {
  const lightScreenDistanceCm = lightObjectDistanceCm + objectScreenDistanceCm;
  return (objectHeightCm * lightScreenDistanceCm) / lightObjectDistanceCm;
}
